import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import block from 'bem-cn';
import { observer } from 'mobx-react';

import { authStore } from 'stores';
import { AUTH_TOKENS_KEY } from 'stores/authStore';

import {RouterPathEnum, DragNDropEvents } from 'shared/enums/commonEnums';

import './RootLayout.scss';

const cnRootLayout = block('RootLayout');

const RootLayout = () => {
  const navigate = useNavigate();

  // Проверка авторизации при первом рендере
  useEffect(() => {
    const isAuthorized = authStore.checkIsAuthorized();
    if (!isAuthorized) {
      navigate(RouterPathEnum.Auth);
    }
  }, []);

  // Перенаправление, если currentUser стал null
  useEffect(() => {
    if (!authStore.currentUser) {
      navigate(RouterPathEnum.Auth);
    }
  }, [authStore.currentUser]);

  // Проверка токена в localStorage через интервалы
  useEffect(() => {
    if (!localStorage.getItem(AUTH_TOKENS_KEY)) {
      navigate(RouterPathEnum.Auth);
    }

    const day = 1000 * 60 * 1400; // интервал можно убрать или изменить по необходимости
    const interval = setInterval(() => {
      if (!localStorage.getItem(AUTH_TOKENS_KEY)) {
        navigate(RouterPathEnum.Auth);
      }
    }, day);

    return () => clearInterval(interval);
  }, []);

  return (
      <div className={cnRootLayout()}>
        <Outlet />
      </div>
  );
};

export default observer(RootLayout);
